export const TextPlaceholder = '—';